// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__16Uk4","bigColWidth":"Table_bigColWidth__2lw2M","biggerColWidth":"Table_biggerColWidth__33opz","row":"Table_row__2HE0j","col":"Table_col__Jhykb"};